import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col" }
const _hoisted_4 = { class: "main-import main-table-fit" }
const _hoisted_5 = { class: "main-import-fit" }
const _hoisted_6 = { class: "import-date" }
const _hoisted_7 = { class: "date-from" }
const _hoisted_8 = /*#__PURE__*/_createVNode("p", { class: "main-import__parag" }, [
  /*#__PURE__*/_createTextVNode(" Дата с "),
  /*#__PURE__*/_createVNode("span", { class: "necessarily" }, "*")
], -1)
const _hoisted_9 = { class: "input-container" }
const _hoisted_10 = { class: "input-container__border" }
const _hoisted_11 = { class: "date-to" }
const _hoisted_12 = /*#__PURE__*/_createVNode("p", { class: "main-import__parag" }, [
  /*#__PURE__*/_createTextVNode(" Дата до "),
  /*#__PURE__*/_createVNode("span", { class: "necessarily" }, "*")
], -1)
const _hoisted_13 = { class: "input-container" }
const _hoisted_14 = { class: "input-container__border" }
const _hoisted_15 = { class: "import-next-table" }
const _hoisted_16 = { class: "table-content" }
const _hoisted_17 = { class: "plus-td" }
const _hoisted_18 = { class: "import-table" }
const _hoisted_19 = { class: "import-box" }
const _hoisted_20 = /*#__PURE__*/_createVNode("option", { value: "none" }, "-", -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("option", { value: "attr" }, "Атрибут", -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("option", { value: "loc" }, "Локация", -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("option", { value: "bilut" }, "Название бюллетени", -1)
const _hoisted_24 = {
  key: 0,
  class: "input-box"
}
const _hoisted_25 = /*#__PURE__*/_createVNode("input", {
  class: "input-box__input",
  type: "text",
  name: "",
  placeholder: "Ед. измерения"
}, null, -1)
const _hoisted_26 = { class: "buttons" }
const _hoisted_27 = /*#__PURE__*/_createVNode("button", { class: "button-cancel" }, "ОТМЕНА", -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_admin_import = _resolveComponent("admin-import")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_admin_import),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                _createVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createVNode("div", null, [
                    _createVNode("div", _hoisted_9, [
                      _createVNode("div", _hoisted_10, [
                        _withDirectives(_createVNode("input", {
                          type: "date",
                          name: "trip-start",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.fromDate = $event)),
                          class: "edit-date__calendar"
                        }, null, 512), [
                          [_vModelText, _ctx.fromDate]
                        ])
                      ])
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createVNode("div", null, [
                    _createVNode("div", _hoisted_13, [
                      _createVNode("div", _hoisted_14, [
                        _withDirectives(_createVNode("input", {
                          type: "date",
                          name: "trip-start",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (_ctx.toDate = $event)),
                          class: "edit-date__calendar"
                        }, null, 512), [
                          [_vModelText, _ctx.toDate]
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_15, [
                _createVNode("div", _hoisted_16, [
                  _createVNode("div", _hoisted_17, [
                    _createVNode("table", _hoisted_18, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data.dataTable, (dataRow, dataRowIndex) => {
                        return (_openBlock(), _createBlock("tr", { key: dataRowIndex }, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(dataRow, (dataColumn, dataColumnIndex) => {
                            return (_openBlock(), _createBlock("td", {
                              key: dataColumnIndex,
                              class: dataColumn.type
                            }, [
                              _createVNode("div", _hoisted_19, [
                                _withDirectives(_createVNode("input", {
                                  "onUpdate:modelValue": $event => (dataColumn.value = $event),
                                  class: "select-attr",
                                  type: "text",
                                  name: ""
                                }, null, 8, ["onUpdate:modelValue"]), [
                                  [_vModelText, dataColumn.value]
                                ]),
                                _withDirectives(_createVNode("select", {
                                  onChange: $event => (
                              _ctx.checkingCells(dataRowIndex, dataColumnIndex)
                            ),
                                  class: "select-type",
                                  "onUpdate:modelValue": $event => (dataColumn.type = $event),
                                  name: ""
                                }, [
                                  _hoisted_20,
                                  _hoisted_21,
                                  _hoisted_22,
                                  _hoisted_23
                                ], 40, ["onChange", "onUpdate:modelValue"]), [
                                  [_vModelSelect, dataColumn.type]
                                ]),
                                (dataColumn.type == 'attr')
                                  ? (_openBlock(), _createBlock("div", _hoisted_24, [
                                      _hoisted_25
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ], 2))
                          }), 128 /* KEYED_FRAGMENT */))
                        ]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    _createVNode("div", {
                      class: "plus",
                      onClick: _cache[3] || (_cache[3] = $event => (_ctx.plusCol()))
                    }, "+"),
                    _createVNode("div", {
                      class: "plus",
                      onClick: _cache[4] || (_cache[4] = $event => (_ctx.minusCol()))
                    }, "-")
                  ]),
                  _createVNode("div", {
                    class: "plus",
                    onClick: _cache[5] || (_cache[5] = $event => (_ctx.plusRow()))
                  }, "+"),
                  _createVNode("div", {
                    class: "plus",
                    onClick: _cache[6] || (_cache[6] = $event => (_ctx.minusRow()))
                  }, "-")
                ])
              ]),
              _createVNode("div", _hoisted_26, [
                _createVNode("button", {
                  class: "button-using",
                  onClick: _cache[7] || (_cache[7] = $event => (_ctx.takeBulletin()))
                }, " ИМПОРТ "),
                _createVNode(_component_router_link, {
                  class: "admin-article-create",
                  "active-class": "active",
                  to: "/admin/import",
                  exact: ""
                }, {
                  default: _withCtx(() => [
                    _hoisted_27
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}